var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
var rootElement = document.documentElement;

function handleScroll() {
  // Do something on scroll
  var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
  if (rootElement.scrollTop / scrollTotal > 0.8) {
    // Show button
    scrollToTopBtn.classList.add("showBtn");
  } else {
    // Hide button
    scrollToTopBtn.classList.remove("showBtn");
  }
}

function scrollToTop() {
  // Scroll to top logic
  rootElement.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
scrollToTopBtn.addEventListener("click", scrollToTop);
document.addEventListener("scroll", handleScroll);



// BUTTON BOTTOM TO TOP END


  $('.abz-new-testi').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
    arrows:true,
    focusOnSelect: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });



// abz-pdp-review-slider


  $('.abz-pdp-review-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows:true,
    adaptiveHeight: false,
    dots: false,    
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });



$(document).ready(function() {
    $("variant-radios").click(function () {
        $("label").removeClass("active");
        $(this).addClass("active");     
    });
});





// Sticky Add To Cart

$(window).scroll(function(){
  if ($(window).scrollTop() >= 600) {
    $('.card-bottom-fix').addClass('fixed');
   }
   else {
    $('.card-bottom-fix').removeClass('fixed');
   }
});


// PDP Page
function abzSliderButtons(btn, mediaCount) {
  const thumbSlider = btn.closest('media-gallery').querySelector('.slider.thumbnail-list');
  const currentThumb = thumbSlider.querySelector('[aria-current="true"]');
  const currentMedia = parseInt(currentThumb.parentElement.dataset.mediaPosition);
  let nextMedia;

  if (btn.name == 'abz-next') { (currentMedia >= mediaCount) ? nextMedia = 1 : nextMedia = currentMedia + 1; } 
  else if (btn.name == 'abz-prev') { (currentMedia <= 1) ? nextMedia = mediaCount : nextMedia = currentMedia - 1; }
  
  nextMedia ? thumbSlider.querySelector(`[data-media-position="${nextMedia}"] .thumbnail`).click() : console.log('ktest');

}
 
